import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Toolbar from "@mui/material/Toolbar";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import CloseIcon from "@mui/icons-material/Close";

import OutlineList from "~/components/OutlineList";

const StyledDrawer = styled(Drawer)({
  "&.MuiDrawer-root": {
    position: "absolute !important",
    right: "unset !important"
  },
  "& .MuiDrawer-paper.MuiPaper-root ": {
    position: "absolute",
    width: 250,
    minWidth: 250
  }
});

const ToggleButton = styled(Button)(({ theme }) => ({
  borderRadius: "0 4px 4px 0",
  backgroundColor: "rgb(224, 225, 225)",
  zIndex: 1000,
  position: "absolute",
  top: "25%",
  left: 0,
  minWidth: 0,
  width: 54,
  height: 54,
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

const StyledOutlineList = styled(OutlineList)({
  overflow: "auto",
  flex: 1
});

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: 46,
  height: 46,
  color: "white",
  backgroundColor: theme.palette.mborange[0],
  fontSize: theme.typography.pxToRem(18)
}));

const CloseBtn = styled(Button)(({ theme }) => ({
  color: "white",
  minWidth: 0,
  position: "absolute",
  right: 0,
  marginRight: 6,
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function MaterialOutlineOverlay({ outline, goToPage, page }) {
  const [isOpen, setIsOpen] = useState(false);

  function closeDrawer() {
    setIsOpen(false);
  }

  function toggleDrawer() {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <StyledDrawer
        anchor="left"
        open={isOpen}
        onClose={closeDrawer}
        ModalProps={{
          disablePortal: true,
          hideBackdrop: true
        }}
      >
        <StyledToolbar>
          <span>Inhaltsverzeichnis</span>
          <CloseBtn onClick={closeDrawer}>
            <CloseIcon />
          </CloseBtn>
        </StyledToolbar>
        <StyledOutlineList
          outline={outline}
          onNodeClick={goToPage}
          onSidebarClose={closeDrawer}
          offset={0}
          pages={[page]}
          openDefault={false}
        />
      </StyledDrawer>
      <Tooltip title="Inhaltsverzeichnis">
        <ToggleButton open={isOpen} variant="contained" onClick={toggleDrawer} disableElevation>
          <FormatAlignLeftIcon />
        </ToggleButton>
      </Tooltip>
    </>
  );
}

MaterialOutlineOverlay.propTypes = {
  outline: PropTypes.array.isRequired,
  goToPage: PropTypes.func.isRequired,
  page: PropTypes.number
};

export default MaterialOutlineOverlay;
